(function() {
  'use strict';

  // Professional designations
  var DESIGNATIONS = [
    'L.Ac.','DC','MD','DO','ND','DVM','DOM','DDS','DPM',
    'L.Ap.','MT','NP','PA','CN','R.Ph.','PhD','PharmD','Other'
  ];

  // Populate designation dropdown
  var typeSel = document.getElementById('license-type');
  if (typeSel) {
    var typeInitial = typeSel.getAttribute('data-initial') || '';
    for (var d = 0; d < DESIGNATIONS.length; d++) {
      var dOpt = document.createElement('option');
      dOpt.value = DESIGNATIONS[d];
      dOpt.textContent = DESIGNATIONS[d];
      if (DESIGNATIONS[d] === typeInitial) dOpt.selected = true;
      typeSel.appendChild(dOpt);
    }
    // If initial value exists but isn't in the list, add it
    if (typeInitial && DESIGNATIONS.indexOf(typeInitial) === -1) {
      var custom = document.createElement('option');
      custom.value = typeInitial;
      custom.textContent = typeInitial;
      custom.selected = true;
      typeSel.appendChild(custom);
    }
  }

  // US states + DC (no territories — license states only)
  var US_STATES = [
    ['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],
    ['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['DC','District of Columbia'],
    ['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],
    ['IN','Indiana'],['IA','Iowa'],['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],
    ['ME','Maine'],['MD','Maryland'],['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],
    ['MS','Mississippi'],['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],
    ['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],['NY','New York'],
    ['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],['OK','Oklahoma'],['OR','Oregon'],
    ['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],['SD','South Dakota'],
    ['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],['VA','Virginia'],
    ['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming']
  ];

  // Populate state dropdown and set initial value from Liquid data attribute
  var stateSel = document.getElementById('license-state');
  if (stateSel) {
    var initial = stateSel.getAttribute('data-initial') || '';
    for (var i = 0; i < US_STATES.length; i++) {
      var opt = document.createElement('option');
      opt.value = US_STATES[i][0];
      opt.textContent = US_STATES[i][1];
      if (US_STATES[i][0] === initial) opt.selected = true;
      stateSel.appendChild(opt);
    }
  }

  // ── Save license (POST only — no on-load GET) ─────────────
  window.__licenseSave = function(e) {
    e.preventDefault();

    var btn = document.getElementById('license-save-btn');
    var txt = document.getElementById('license-save-text');
    var spin = document.getElementById('license-save-spinner');
    btn.disabled = true;
    txt.textContent = 'Saving...';
    spin.style.display = '';

    var payload = {
      licenseType: document.getElementById('license-type').value,
      licenseNumber: document.getElementById('license-number').value.trim(),
      licenseState: document.getElementById('license-state').value,
      licenseExpiration: document.getElementById('license-expiration').value
    };

    fetch('/apps/purchase-history/license', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      btn.disabled = false;
      txt.textContent = 'Save';
      spin.style.display = 'none';

      if (data.error) {
        __acctToast(data.error, 'error');
      } else {
        __acctToast('License saved.');
      }
    })
    .catch(function(err) {
      btn.disabled = false;
      txt.textContent = 'Save';
      spin.style.display = 'none';
      __acctToast('Something went wrong. Please try again.', 'error');
      console.error('License save error:', err);
    });

    return false;
  };
})();
